"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLocalStorageTabExpanded = isLocalStorageTabExpanded;
exports.setPinnedLocalStorage = exports.searchTabRoutes = exports.removePinnedLocalStorage = void 0;
exports.updateTabsExpandedLocalStorage = updateTabsExpandedLocalStorage;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _reactRouterDom = require("react-router-dom");
var _SidenavConsts = require("./SidenavConsts");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function getTabsExpandedSet() {
  var tabsExpandedJSON = localStorage.getItem(_SidenavConsts.LOCAL_STORAGE_KEYS.SIDENAV_TABS_EXPANDED);
  return new Set(JSON.parse(tabsExpandedJSON));
}
function getTabIdForLocalStorage(tabIndex, tabText) {
  return "".concat(tabIndex, "-").concat(tabText);
}
function isLocalStorageTabExpanded(_ref) {
  var tabIndex = _ref.tabIndex,
    tabText = _ref.tabText;
  try {
    return getTabsExpandedSet().has(getTabIdForLocalStorage(tabIndex, tabText));
  } catch (e) {
    return false;
  }
}
function resetTabsExpandedSet() {
  localStorage.setItem(_SidenavConsts.LOCAL_STORAGE_KEYS.SIDENAV_TABS_EXPANDED, '[]');
}
function setTabsExpandedLocalStorage(tabsExpandedSet) {
  localStorage.setItem(_SidenavConsts.LOCAL_STORAGE_KEYS.SIDENAV_TABS_EXPANDED, JSON.stringify((0, _toConsumableArray2["default"])(tabsExpandedSet)));
}
function updateTabsExpandedLocalStorage(_ref2) {
  var action = _ref2.action,
    tabIndex = _ref2.tabIndex,
    tabText = _ref2.tabText;
  try {
    var tabsExpanded = getTabsExpandedSet();
    switch (action) {
      case 'add':
        {
          tabsExpanded.add(getTabIdForLocalStorage(tabIndex, tabText));
          break;
        }
      case 'delete':
        {
          tabsExpanded["delete"](getTabIdForLocalStorage(tabIndex, tabText));
          break;
        }
      default:
        {
          // eslint-disable-next-line no-console
          console.warn('Invalid action');
        }
    }
    setTabsExpandedLocalStorage(tabsExpanded);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    resetTabsExpandedSet();
  }
}
var setPinnedLocalStorage = function setPinnedLocalStorage() {
  localStorage.setItem(_SidenavConsts.LOCAL_STORAGE_KEYS.SIDENAV_PINNED, _SidenavConsts.LOCAL_STORAGE_KEYS.SIDENAV_PINNED_VALUE);
};
exports.setPinnedLocalStorage = setPinnedLocalStorage;
var removePinnedLocalStorage = function removePinnedLocalStorage() {
  localStorage.removeItem(_SidenavConsts.LOCAL_STORAGE_KEYS.SIDENAV_PINNED);
};
exports.removePinnedLocalStorage = removePinnedLocalStorage;
var pathMatchesRoute = function pathMatchesRoute(tabRoute, currentPath) {
  var noPath = ['', '/'].includes(tabRoute);
  return (0, _reactRouterDom.matchPath)(currentPath, {
    exact: noPath,
    path: tabRoute,
    strict: true
  });
};
var searchTabRoutes = function searchTabRoutes(currentPath, sidenavTabs) {
  for (var i = 0; i < sidenavTabs.length; i++) {
    var _sidenavTabs$i = sidenavTabs[i],
      route = _sidenavTabs$i.route,
      _sidenavTabs$i$subSec = _sidenavTabs$i.subSections,
      subSections = _sidenavTabs$i$subSec === void 0 ? [] : _sidenavTabs$i$subSec;
    var _split = (route || '').split('?'),
      _split2 = (0, _slicedToArray2["default"])(_split, 1),
      routeWithoutQuery = _split2[0];
    if (route && pathMatchesRoute(routeWithoutQuery, currentPath)) {
      return {
        tabIndex: i,
        tabRoute: route
      };
    }
    // eslint-disable-next-line no-restricted-syntax
    var _iterator = _createForOfIteratorHelper(subSections),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var subSection = _step.value;
        // eslint-disable-next-line no-restricted-syntax
        var _iterator2 = _createForOfIteratorHelper(subSection.childTabs),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var childTab = _step2.value;
            var _split3 = (childTab.route || '').split('?'),
              _split4 = (0, _slicedToArray2["default"])(_split3, 1),
              childTabRouteWithoutQuery = _split4[0];
            if (pathMatchesRoute(childTabRouteWithoutQuery, currentPath)) {
              return {
                tabIndex: i,
                tabRoute: childTab.route
              };
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return null;
};
exports.searchTabRoutes = searchTabRoutes;